<template>
    <!--画图-->
    <div
            @click="clickFn()"
            :id="`comp${  idk  }`"
            class="p-relative p-line-height1"
            :style="`width:${ width }px; height:${ height }px; font-size:${ fontSize }px; color:${ color };  background:${ componentColor };  padding-top:${  padding[0]  }; padding-right:${  padding[1]  }; padding-bottom:${  padding[2]  }; padding-left:${  padding[3]  };`"
    >
        <!--虚线-->
        <ul  @click="clickFn()"  id="yZhou2"  class="p-relative">
            <li  v-if="key!==0"  v-for="(val,key) in yAxis"  class="p-width100"  style="position:absolute; left:0px; border-bottom:1px dashed #cccccc;"  :style="`top:calc(${ height }px - (${ height }px / ${ yAxis.length-1 })*${ key });`">
            </li>
        </ul>


        <canvas  id="canvas"  :width="width"  :height="height"   class="canvas9999 p-relative" style="border-bottom:1px solid black;"  :style="`background:${  canvasColor  };`"></canvas>


        <div  id="parent"  style="position:absolute; left:0px; top:0px;"  :style="`width:${ width }px; height:${ height }px; left:${  padding[3]  }; top:${  padding[0]  };`">
          
            <ul  id="xZhou"  class="p-width100"  style="position:absolute; left:0px;"  :style="`top:${ height+textSpace }px;`">
                <li  v-for="val in xAxis"  class="p-float-left p-relative p-center"  :style="`width:calc(${ width }px / ${ xAxis });`"  >
					    <span  >{{xAxisStrs[val-1]}}</span>
                </li>
            </ul>


            <!--y轴标量（包括虚线）-->
            <ul  id="yZhou">
                <li  v-for="(val,key) in yAxis"  style="position:absolute;"  :style="`left:${ width+textSpace }px; top:calc(${ height }px - (${ height }px / ${ yAxis.length-1 })*${ key } - ${  fontSize/3  }px);`">
                    {{  val*scale | fmoney  }}
                </li>
            </ul>



            <!--滚动轴  ${  axiosWidth  }px-->
            <div
                    id="drag"
                    class="p-box-center p-pointer p-user-select"
                    style="position:absolute; top:0px; left:0px;"
                    :style="`width:${  axiosWidth  }px; height:${  height  }px; background:${  axiosColor  };`"
            >
                <div  :style="`height:100%;`">
                    <!--按钮显示值 s-lightRed-bg -->
                    <div
                        v-show="returnData.y>0"
                        class="p-relative p-inline-block p-white-text p-center"
                        style="line-height:2.2; opacity:0.8"
                        :style="`border-radius:${  fontSize*2.2  }px; font-size:${  fontSize*1.2  }px; background:${  btnColor  };`"
                    >
                        <div  class="p-inline-block"  style=" height:1rem; z-index:2;"    :style="`min-width:2rem; width:auto; white-space:nowrap; padding:0px 0.7rem;`">
                            <slot name="default"></slot>
                        </div>


                        <!--尖角-->
                        <div
                                style="position:absolute; left:50%; transform:translateX(-50%) rotate(45deg) skew(20deg,20deg); background:inherit;"
                                :style="`bottom:${  fontSize*(-0.5)  }px; width:${  fontSize  }px; height:${  fontSize  }px;`"
                        >

                        </div>
                    </div>

                    <!--透明轴-->
                    <div
                            style="position:absolute; top:0px;"
                            :style="`left:calc((${  btnWidth  }px - ${ axiosWidth }px) / 2 * (-1)); width:${  btnWidth  }px; height:${  height  }px`">
                    </div>
                </div>
            </div>


        </div>


    </div>
</template>

<script>
    // import { mapState } from 'vuex'
    // import time from 'js-time.js'
    // import { isPC,fmoney,drag } from '@/utils/methods.js'

    import mixins2 from '@/utils/mixins2.js'

    export default {
        name: "pillarNibpReport",
        mixins:[mixins2],
        props:{
            isCircle:{  type:Boolean, required:false, default:false  },  // 渐变线是否两端有圆
        },
        methods:{
            scrollSuccess(docu,context){
                let left = Number.parseFloat(docu.querySelector("#drag").style.left);
                this.returnData = {  x:left, y:" ", y2:" ", y3:" ", y4:" "  };


                if(  this.dots.length > 0  ){
                    let min = this.dots[0]["x"];    // 最小值
                    let index = 0;   // 最小值的索引


                    // 在dots中，循环获取最接近的点集
                    for(  let i=1; i<this.dots.length; i++  ){
                        let item = this.dots[i];

                        // 循环点到滑动轴的x距离<minAxisSpace*0.5     循环点到滑动轴的x距离 < 之前保存的最小x距离
                        if(  Math.abs(item["x"]-left) < this.minAxisSpace*0.5  &&  Math.abs(item["x"]-left) < Math.abs(min-left)  ){
                            min = item["x"];
                            index = i;
                        }
                    }


                    // 保存的到滑动轴的x距离<minAxisSpace*0.5时，才会进行二次滚动
                    if(  Math.abs(min-left) < this.minAxisSpace*0.5  ){
                        // console.log("存在重合点");
                        left = min;
                        // 滚动轴选中点集
                        let item = this.dots.find(function(currentValue){
                            return currentValue.x === left;
                        });

                        docu.querySelector("#drag").style.left = (left - this.axiosWidth*0.5) + "px";
                        this.resetCanvas(context);
                        if(  item  ){
                            // if(  this.type==='pillar'  ){
                            //     this.pillar(context,{  x:item["x"], y:item["y"]  },this.colorArr[1],this.lineWidth);
                            // }
                            // else if(  this.type==='gradientLine'  ){
                                if(  item["y"]===item["y2"]  ){
                                    this.circle(context,{  x:item["x"], y:item["y"]  },this.lineWidth*2,this.colorArr[3]);
                                }
                                else{
                                    this.circle(context,{  x:item["x"], y:item["y"]+this.lineWidth  },this.lineWidth*2,this.colorArr[1]);
                                    this.line(context,{  x:item["x"], y:item["y"]  },{  x:item["x"], y:item["y2"]  },[this.colorArr[1],this.colorArr[3]],this.lineWidth);
                                    this.circle(context,{  x:item["x"], y:item["y2"]-this.lineWidth  },this.lineWidth*2,this.colorArr[3]);
                                }
                            // }
                            // else if(  this.type==='oneLine'  ){
                            //     if(  item["y"]===item["y2"  ]  )  this.circle(context,{  x:item["x"], y:item["y"]  },this.lineWidth/2,this.colorArr[1]);
                            //     else  this.line(context,{  x:item["x"], y:item["y"]  },{  x:item["x"], y:item["y2"]  },[this.colorArr[1],this.colorArr[1]],this.lineWidth);
                            // }
                            // else if(  this.type==='twoLine'  ){
                            //     this.line(context,{  x:item["x"], y:item["y"]  },{  x:item["x"], y:item["y4"]  },[this.colorArr[1],this.colorArr[1]],this.lineWidth/3);

                            //     if(  item["y"]===item["y2"]  )  this.circle(context,{  x:item["x"], y:item["y"]  },this.lineWidth*1.2,this.colorArr[1]);
                            //     else  this.line(context,{  x:item["x"], y:item["y"]  },{  x:item["x"], y:item["y2"]  },[this.colorArr[1],this.colorArr[1]],this.lineWidth*2);

                            //     if(  item["y3"]===item["y4"]  )  this.circle(context,{  x:item["x"], y:item["y3"]  },this.lineWidth*0.6,this.colorArr[3]);
                            //     else  this.line(context,{  x:item["x"], y:item["y3"]  },{  x:item["x"], y:item["y4"]  },[this.colorArr[3],this.colorArr[3]],this.lineWidth);
                            // }
                            this.returnData = {  x:item.x, y:item.y*this.scale, y2:item.y2*this.scale, y3:item.y3*this.scale, y4:item.y4*this.scale  };
                        }
                    }
                    else{
                        this.resetCanvas(context);
                    }
                }

                // 发送数据到父级,避免sendData比请求接口的数据更快，显示上一次的数据--------------------------------------------------------------------------
				/* let timer = setTimeout(()=>{
					this.$emit("sendData",this.returnData);
										
					clearTimeout(timer);
				},500); */
				this.$emit("sendData",this.returnData);
            },

            // 整体画完
            canvasAll(context){
                context.clearRect(0,0,this.width,this.height);

                for(  let i in this.dots  ){
                    let item = this.dots[i];

                    // if(  this.type==='pillar'  ){
                    //     this.pillar(context,{  x:item["x"], y:item["y"]  },this.colorArr[0],this.lineWidth);
                    // }
                    // else if(  this.type==='gradientLine'  ){
                        if(  item["y"]===item["y2"]  ){
                            this.circle(context,{  x:item["x"], y:item["y"]  },this.lineWidth*2,this.colorArr[0]);
                        }
                        else{
                            this.circle(context,{  x:item["x"], y:item["y"]+this.lineWidth  },this.lineWidth*2,this.colorArr[0]);
                            this.line(context,{  x:item["x"], y:item["y"]  },{  x:item["x"], y:item["y2"]  },[this.colorArr[0],this.colorArr[2]],this.lineWidth);
                            this.circle(context,{  x:item["x"], y:item["y2"]-this.lineWidth  },this.lineWidth*2,this.colorArr[0]);
                        }
                    // }
                    // else if(  this.type==='oneLine'  ){
                    //     if(  item["y"]===item["y2"  ]  )  this.circle(context,{  x:item["x"], y:item["y"]  },this.lineWidth/2*1.2,this.colorArr[0]);
                    //     else  this.line(context,{  x:item["x"], y:item["y"]  },{  x:item["x"], y:item["y2"]  },[this.colorArr[0],this.colorArr[0]],this.lineWidth);
                    // }
                    // else if(  this.type==='twoLine'  ){
                    //     this.line(context,{  x:item["x"], y:item["y"]  },{  x:item["x"], y:item["y4"]  },[this.colorArr[0],this.colorArr[0]],this.lineWidth/3);

                    //     if(  item["y"]===item["y2"]  )  this.circle(context,{  x:item["x"], y:item["y"]  },this.lineWidth*1.2,this.colorArr[0]);
                    //     else  this.line(context,{  x:item["x"], y:item["y"]  },{  x:item["x"], y:item["y2"]  },[this.colorArr[0],this.colorArr[0]],this.lineWidth*2);

                    //     if(  item["y3"]===item["y4"]  )  this.circle(context,{  x:item["x"], y:item["y3"]  },this.lineWidth*0.6,this.colorArr[2]);
                    //     else  this.line(context,{  x:item["x"], y:item["y3"]  },{  x:item["x"], y:item["y4"]  },[this.colorArr[2],this.colorArr[2]],this.lineWidth);
                    // }
                }

            },
        },


    }
</script>